import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "customInput"];
  static values = {
    initialValue: String,
    phoneNumbers: Array,
  };

  connect() {
    // On page load, determine if initial value is a Kallglot number or custom
    if (this.initialValueValue) {
      const isKallglotNumber = this.phoneNumbersValue.some(
        (pn) => pn.e164 === this.initialValueValue
      );

      if (isKallglotNumber) {
        // It's a Kallglot number - select it in the dropdown
        if (this.hasSelectTarget) {
          this.selectTarget.value = this.initialValueValue;
        }
        if (this.hasCustomInputTarget) {
          this.customInputTarget.value = "";
        }
      } else {
        // It's a custom number - clear select and populate custom input
        if (this.hasSelectTarget) {
          this.selectTarget.value = "";
        }
        if (this.hasCustomInputTarget) {
          this.customInputTarget.value = this.initialValueValue;
        }
      }
    }
  }

  selectPhone(event) {
    const selectedValue = event.target.value;

    if (selectedValue) {
      // A Kallglot number was selected - clear custom input
      if (this.hasCustomInputTarget) {
        this.customInputTarget.value = "";
      }
    }
  }

  // When user types in custom input, clear the select dropdown
  inputCustom() {
    if (this.hasSelectTarget && this.hasCustomInputTarget) {
      if (this.customInputTarget.value.trim()) {
        this.selectTarget.value = "";
      }
    }
  }
}
